import { Box } from "@mui/material";
import InlineSVG from "react-inlinesvg";

type Props = {
  name: string;
  size?: number;
  fill?: string;
};

export const Icon = ({ name, size = 24, fill = "currentColor" }: Props) => {
  const src = `/icons/${name}.svg`;

  return (
    <Box component="div" display="flex" title={name} aria-label={name}>
      <InlineSVG src={src} fill={fill} width={size} height={size} />
    </Box>
  );
};
